module.exports = __webpack_public_path__ + "img/Dantam Fashion 15.edaf6451.jpg";